/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerFindAllQueryResponse, TemplateActivationsControllerFindAllQueryParams, TemplateActivationsControllerFindAll401, TemplateActivationsControllerFindAll403 } from "../../models/checklistsController/TemplateActivationsControllerFindAll";

function getTemplateActivationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-activations` as const }  
  return res
}

/**
 * @summary List template activations
 * {@link /api/v1/checklist-template-activations}
 */
export async function templateActivationsControllerFindAll(params?: TemplateActivationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateActivationsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindAll401 | TemplateActivationsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateActivationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}